import Req from '../../$axios'

const serviceModule = {
  download(params, fn) {
    return Req(
      {
        url: '/download',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true,
        isFile: true,
        onDownloadProgress: fn
      },
      params
    )
  },
}

export default {
  ...serviceModule
}
